import { BATCH_CONTENT_TYPE_ID } from '@cont/Batch/utils';
import useFetch from '@hooks/useFetch';
import { HOST_TYPE } from '@utils/api-helper/host';

export const getKey = (batchUID, goalUID) =>
  `v1/subscriptions/user/store_skus/?content_type_id=${BATCH_CONTENT_TYPE_ID}&object_uid=${batchUID}&goal_uid=${goalUID}&send_extra_details=True&centre_sub_required=True`;

const useBatchSkuDetails = (goalUID, batchUID) => {
  const key = getKey(batchUID, goalUID);

  const { data: batchSkuDetails, ...rest } = useFetch(goalUID ? key : null, {
    hostType: HOST_TYPE.BACKEND_API_HOST
  });

  return {
    key,
    batchSkuDetails,
    ...rest
  };
};

export default useBatchSkuDetails;
